import { Value } from '@philips-internal/oswald-ui-core';

interface ParamsProps {
  buttonName?: string;
  doseQuantity?: string;
  doseUnitMeasureCode?: string;
  eventDate?: string;
  hourSequence?: string;
  itemCode?: string;
  medicationName?: string;
  prescriptionNumber?: string;
}

interface ParamButtonNameProps {
  buttonName?: string;
}

interface PatientInfosProps {
  patientInfos?: Value;
}

interface AdminScheduleProps {
  dilutionDescription?: string;
  materialSequence?: number;
  medicationHour?: string;
  prescriptionNumber?: number;
}

export class OralSupplementsViewerParams {
  static params: ParamsProps;
  static paramButton: ParamButtonNameProps;
  static infos: PatientInfosProps;
  static adminSchedule: AdminScheduleProps;
}

export const Function1113Param13Values = {
  DO_NOT_CONTROL: 'NC',
  NO: 'N',
  NOT_ALLOWED: 'NP',
  NOT_ALLOWED_AND_jUSTIFICATION: 'NPE',
  REQUIRED_JUSTIFICATION: 'EJ',
}

export const Function9129Param13Values = {
  DEPENDS_ON_THE_RULE: 'D',
  NO: 'N',
  YES: 'S',
}

export const OralSupplementsStatusItem = {
  ADMINISTERED: 'ADMINISTERED',
  SUPPLEMENTS_ADMINISTERED: 'A'
}